import React from 'react'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

import useCheckoutButton from '../../../checkout/hooks/checkout-button'
import PaypalButton from '../../../../components/paypal-button'
import ApplePayButton from '../../../../components/applepay-button'
import GooglePayButton from '../../../../components/google-button'
import { BigButton } from '../../../../../../components/button'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { country, orderTotal, payMethod, klarnas, onError, inputOrder, selectedCard, redirectType } = props

    const {
        paying,
        pay
    } = useCheckoutButton({
        klarnas,
        payMethod,
        onError,
        inputOrder,
        selectedCard,
        redirectType
    })

    const usePaypalButton = payMethod?.type === '1'
    const useAppleButton = payMethod?.type === '32'
    const useGoogleButton = payMethod?.type === '41'

    const clickHandle = () => {
        if(!payMethod){
            onError({type: 'no_paymethod'})
        }else{
            pay()
        }
    }

    return <>
        {
            usePaypalButton && <PaypalButton redirectType="order" inputOrder={inputOrder} onError={onError} className={classes.PaypalButton} />
        }

        {
            useAppleButton && <ApplePayButton inputOrder={inputOrder} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={country} />
        }

        {
            useGoogleButton && <GooglePayButton inputOrder={inputOrder} onError={onError} payMethod={payMethod?.id} orderTotal={orderTotal} country={country} />
        }

        {
            !usePaypalButton && !useAppleButton && !useGoogleButton && <BigButton loading={paying} className={`${classes.CheckoutButton} ${props.className}`} onClick={clickHandle}>
                <FormattedMessage id="pay_now" defaultMessage="Pay Now" />
            </BigButton>
        }
    </>
}